import { render, staticRenderFns } from "./home-copy.vue?vue&type=template&id=5a54ad26&scoped=true&"
import script from "./home-copy.vue?vue&type=script&lang=js&"
export * from "./home-copy.vue?vue&type=script&lang=js&"
import style0 from "./home-copy.vue?vue&type=style&index=0&id=5a54ad26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a54ad26",
  null
  
)

export default component.exports